import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import opts from './plugins/vuetify'
import App from './App.vue'
import router from './router.js'
import store from './store/store'
import VueI18n from 'vue-i18n'
import messages from './i18n/translations.js'
import Axios from 'axios'
import cookies from 'js-cookie'
import SModal from '@/components-shared/utils/SModal.vue'
import './assets/styles/main.scss'
import './assets/styles/styles.scss'
import { Touch, Ripple } from 'vuetify/lib/directives'
import PermissionHandler from '@/classes-shared/routerHelper/PermissionHandler'
import AsyncComputed from 'vue-async-computed'
import VCalendar from 'v-calendar'
import moment from 'moment'

// make axios global
global.axios = Axios

// Event Bus
global.EventBus = new Vue()

global.store = store

if (process.env.VUE_APP_REDIRECT_URL) {
  console.log('REDIRECT_URL', process.env.VUE_APP_REDIRECT_URL)
  window.location.href = process.env.VUE_APP_REDIRECT_URL
}

// register components globally
Vue.component('SModal', SModal)

// register plugins
Vue.use(VueI18n)
Vue.use(Vuetify, { directives: { Touch, Ripple } })
Vue.use(AsyncComputed)
Vue.use(VCalendar, {
  firstDayOfWeek: 2, // Monday
  componentPrefix: 'vc',
})

//internationalization
const i18n = new VueI18n({
  locale: 'de', // set locale
  fallbackLocale: 'de',
  messages, // set locale messages,
  silentTranslationWarn: true,
  missing: () => {
    return 'Missing Translation'
  },
})

global.i18n = i18n

// perform auto login
router.beforeEach(async (to, from, next) => {
  // 1.) routes just to go (avoid endless loops)
  if (
    to.name === 'login' ||
    to.name === 'success' ||
    to.name === 'error' ||
    to.name === 'bookingHistory' ||
    to.name === 'loadingDestination'
  ) {
    next({ patch: to.path })
    return
  }
  // 2.) check if app destination available => app destination has to be loaded to check permissions right in the following
  // PermissionHandler.js
  if (!store.getters.getAppDestinationInstance()) {
    next({ name: 'loadingDestination', params: { toRoute: to } })
    return
  }

  // 3.) handle auto login
  if (
    store.state.authorization === 0 &&
    cookies.get('authorization') &&
    cookies.get('uid')
  ) {
    // redirecting from shop-admin frontend
    if (to.name === 'priceOverrideViewForEvents') {
      to.params.redirect = 'priceOverrideViewForEvents'
      to.params.redirectQuery = JSON.stringify(to.query)
    }
    // if cookies exist but user is not logged in => routing to login, where the auto login will perform
    next({ name: 'login', params: to.params })
    return
  }

  // 4.) handle normal permission checks
  if (PermissionHandler.hasPermission(to.meta)) {
    next()
  } else {
    // make custom redirects
    if (to.name === 'priceOverrideViewForEvents') {
      // redirecting from shop-admin frontend
      to.params.redirect = 'priceOverrideViewForEvents'
      to.params.redirectQuery = JSON.stringify(to.query)
      next({ name: 'login', params: to.params })
    } else {
      // no access right page
      if (store.getters.isUserLoggedIn()) {
        next({ name: 'noAccess' })
      } else {
        next({ name: 'login' })
      }
    }
  }
})

/* directives */
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  },
})

/* defining global filters */
Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('upperCase', (text) => {
  if (!text) return ''
  return text.toUpperCase()
})

Vue.filter('maxLength', (value, maxLength = 20) => {
  if (!value) return ''
  value = value.toString()
  if (value.length <= maxLength) return value
  return value.substr(0, maxLength) + '...'
})

Vue.filter('formatDate', (value, format = 'DD.MM.YYYY') => {
  if (!value) return ''
  let mom = moment(value)
  mom.locale(i18n.locale)
  return mom.format(format)
})

// currency
Vue.filter('currency', (amount, showCurrency = true) => {
  if (amount == null) amount = 0

  const number = (parseFloat(amount) / 100)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  if (showCurrency) {
    return `${store.getters
      .getCurrentDestinationInstance()
      .getCurrency()} ${number}`
  }

  return number
})

// centimes to francs
Vue.filter('centimesToFr', (amount, stepped = false) => {
  if (stepped) {
    amount = amount / 100
    return (Math.ceil(amount * 20) / 20).toFixed(2)
  }
  /* eslint no-undef: 'off' */
  return _.round(amount / 100, 2)
})
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  vuetify: new Vuetify(opts),
  render: (h) => h(App),
}).$mount('#app')
